import React, { FC } from "react";
import { FormattedMessage } from "react-intl";
import { ElevioBorderlessButton, ElevioBorderlessButtonProps } from "./ElevioBorderlessButton";

export const ElevioLearnMoreButton: FC<ElevioBorderlessButtonProps> = ({ articleId, asLink, className, onClick }) => (
  <ElevioBorderlessButton articleId={articleId} asLink={asLink} className={className} onClick={onClick}>
    <FormattedMessage id="common.learnMore" defaultMessage="Learn more" />
  </ElevioBorderlessButton>
);
